import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

// Brian's business WhatsApp line (from footer contact info)
const WHATSAPP_NUMBER = '447957166339';
const WHATSAPP_PREFILL = encodeURIComponent(
  "Hi Brian — I'd like to chat about Paisley Scotland."
);
const WA_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_PREFILL}`;

export const WhatsAppFloatingButton = () => {
  const [tooltipOpen, setTooltipOpen] = useState(true);

  return (
    <div
      className="fixed bottom-6 right-6 z-40 flex items-end gap-2 sm:bottom-8 sm:right-8"
      data-testid="whatsapp-float"
    >
      {tooltipOpen && (
        <div className="hidden sm:flex items-center gap-2 bg-white shadow-lg border border-slate-200 rounded-full pl-4 pr-2 py-2 animate-fade-in-up">
          <span className="text-sm font-medium text-slate-700 whitespace-nowrap">
            Chat with us on WhatsApp
          </span>
          <button
            onClick={() => setTooltipOpen(false)}
            className="h-5 w-5 inline-flex items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100"
            aria-label="Dismiss"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      )}
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
        data-testid="whatsapp-btn"
        className="group relative inline-flex items-center justify-center h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/40 hover:bg-[#1ebe5d] hover:scale-105 transition-all"
      >
        {/* WhatsApp glyph */}
        <svg viewBox="0 0 32 32" className="h-7 w-7 sm:h-8 sm:w-8" fill="currentColor" aria-hidden="true">
          <path d="M16.001 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.6 4.46 1.74 6.4L3.2 28.8l6.6-1.72a12.74 12.74 0 0 0 6.2 1.58h.01c7.07 0 12.79-5.73 12.79-12.8 0-3.42-1.33-6.63-3.75-9.04A12.7 12.7 0 0 0 16 3.2zm0 23.27h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.92 1.03 1.05-3.82-.25-.4a10.6 10.6 0 0 1-1.62-5.66c0-5.87 4.78-10.65 10.65-10.65 2.85 0 5.52 1.11 7.53 3.13a10.57 10.57 0 0 1 3.12 7.53c0 5.87-4.78 10.55-10.76 10.55zm5.83-7.93c-.32-.16-1.9-.94-2.2-1.05-.3-.11-.51-.16-.73.16-.22.32-.84 1.05-1.03 1.27-.19.22-.38.24-.7.08-.32-.16-1.36-.5-2.6-1.6-.96-.86-1.6-1.93-1.79-2.25-.19-.32-.02-.49.14-.65.14-.14.32-.38.49-.57.16-.19.21-.32.32-.54.11-.22.05-.4-.03-.57-.08-.16-.73-1.76-1-2.41-.26-.63-.53-.55-.73-.56l-.62-.01c-.21 0-.57.08-.86.4-.3.32-1.13 1.1-1.13 2.69 0 1.59 1.16 3.12 1.32 3.34.16.22 2.28 3.49 5.53 4.89.77.33 1.38.53 1.85.68.78.25 1.49.21 2.05.13.62-.09 1.9-.78 2.17-1.53.27-.74.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37z" />
        </svg>
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>
      </a>
    </div>
  );
};

export default WhatsAppFloatingButton;
